import * as React from 'react';
import Icon from '@narvar/nth-bit-icon-button';
import Close from '@narvar/nth-close';

interface DismissProps {
  s?: React.CSSProperties;
  onClick?: () => void;
}

const Dismiss: React.FunctionComponent<DismissProps> = ({
  s = {},
  onClick,
}) => (
  <Icon onClick={onClick} ariaLabel="close">
    <Close s={s} />
  </Icon>
);

export default Dismiss;
